import React from "react";
import { ScanningSessionContextProvider } from "./scanned-items-context/scanning-session-context";
import { CodeScannerContextProvider } from "./code-scanner-context/code-scanner-context";
import { NotificationContextProvider } from "./notification-context/notification-context";

interface IAppContextProviderProps {
    children: React.ReactNode;
}

export const AppContextProvider = (props: IAppContextProviderProps) => {
    return <CodeScannerContextProvider>
        <ScanningSessionContextProvider>
            <NotificationContextProvider>
                <div className={"page"}>
                    {props.children}
                </div>
            </NotificationContextProvider>
        </ScanningSessionContextProvider>
    </CodeScannerContextProvider>;
};
